const canvasBuccalSx = (theme) => ({
    buccalContainer: {
        //width: '100%',
        //height: '100%',
        //minHeight: '100%',
        //display: 'table',
        //maxHeight: 'calc(100vh - 200px)',
        // keep container minimal — original comments indicated potential blur issues
    },
});

export default canvasBuccalSx;
